import React from "react";

import KnowledgeCenterWithFilterOptions from "~/blocks/KnowledgeCenterWithFilterOptions";

import useGetBasePath from "~/hooks/useGetBasePath";

const getFilterOptions = (category, parent) => {
    const { productLine, type, topic } = category || {};
    if (productLine || type || topic) {
        return category;
    }

    return parent;
};

const getArticles = (category, parent) => {
    const childArticles = category?.individualArticles;
    const parentArticles = parent?.individualArticles;
    return childArticles ?? parentArticles;
};

const getVeiwAll = (category, parent) => {
    const childViewAll = category?.viewAllUrl;
    const parentViewAll = parent?.viewAllUrl;
    return childViewAll ?? parentViewAll;
};

const ProductCategoryKnowledgeCenter = ({ data }) => {
    const {
        parentCategory,
        wpProductCategory: { categoryData },
    } = data;

    const getBasePath = useGetBasePath();

    const category = categoryData?.knowledgeCenterArticles;
    const parent = parentCategory?.categoryData?.knowledgeCenterArticles;
    const filterOptions = getFilterOptions(category, parent);
    const cards = getArticles(category, parent);
    const viewAllUrl = getVeiwAll(category, parent);

    return (
        <KnowledgeCenterWithFilterOptions
            title="Knowledge Center"
            sectionId={categoryData?.knowledgeCenterSectionId}
            linkLabel="View All"
            linkUrl={viewAllUrl ?? getBasePath("knowledgeCenterBase")?.url}
            linkAriaLabel="View All Knowledge Center Items"
            filterOptions={filterOptions}
            cards={cards}
            withBorder
        />
    );
};

export default ProductCategoryKnowledgeCenter;
